import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { SharedModule } from '@ddt-web/common';
import { DataServiceModule } from '@ddt-web/data-service';
import { GenericDirectivesModule, GenericPipesModule } from '@ddt-web/generic-utils';

import { SidenavComponent } from './sidenav.component';

@NgModule({
	declarations: [SidenavComponent],
	imports: [CommonModule, CwpNgFrameworkModule, GenericPipesModule, GenericDirectivesModule, RouterModule, DataServiceModule, SharedModule],
	exports: [SidenavComponent]
})
export class SidenavModule { }
